module.exports = __webpack_public_path__ + "static/media/bloco2img2.682bb8c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/EVisual/bloco2img2.jpg
// module id = 121
// module chunks = 0